import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, Typography } from "@mui/material";

const PurchaseFrequencyField = ({
  purchaseFrequency,
  setPurchaseFrequency,
}: {
  purchaseFrequency: number;
  setPurchaseFrequency: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <TextField
        type="number"
        size="small"
        value={purchaseFrequency}
        onChange={(e) => setPurchaseFrequency(Number(e.target.value))}
        inputProps={{ min: 1 }}
        sx={{ width: 80 }}
      />
      <Typography color="primary">
        {t(
          "quest_edit_target.field.purchase.content.by_purchase_frequency.label",
        )}
      </Typography>
      <Typography color="primary">
        {t(
          "quest_edit_target.field.purchase.content.by_purchase_frequency.note",
        )}
      </Typography>
    </Stack>
  );
};

export default PurchaseFrequencyField;
